import { JsApiClient } from 'mh-client';

let clientInstance: JsApiClient | null = null;

function handleSessionExpired(): void {
    // Don't redirect if already on an auth page (e.g., verifying magic link)
    if (window.location.pathname.startsWith('/login')) {
        console.warn('[ApiClient] Session error on auth page, not redirecting');
        return;
    }

    console.warn('[ApiClient] Session expired, redirecting to login');
    clientInstance = null;
    window.location.href = '/login';
}

export function getApiClient(): JsApiClient {
    if (!clientInstance) {
        // Server-injected runtime override (e2e uses '' for relative URLs +
        // express proxy); falls back to the build-time absolute URL.
        const runtimeApiUrl = (window as { __RUNTIME_API_URL__?: string })
            .__RUNTIME_API_URL__;
        const apiUrl = runtimeApiUrl ?? import.meta.env.VITE_SERVER_URL;
        const appLinkUrl =
            import.meta.env.VITE_APP_ORIGIN || window.location.origin;
        const isDebug = import.meta.env.DEV;

        clientInstance = new JsApiClient(
            apiUrl,
            appLinkUrl,
            isDebug,
            handleSessionExpired
        );
    }
    return clientInstance;
}

export function resetApiClient(): void {
    if (clientInstance) {
        clientInstance.close();
        clientInstance = null;
    }
}
